import React from 'react';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { ChecklistMockup } from '../mockups/ChecklistMockup';
export function OpenSecureSlide() {
  return <StepSlide step={2} title={'Open "Secure your account"'} visual={<ChecklistMockup data-id="element-227" data-mp="1tx57q0uwxuuf" />} visualLabel="Stripe setup checklist with Verify your business completed and Secure your account marked Click here" data-id="element-226" data-mp="1oz3dcjs1e93n">
      <StepList items={[<>
            You'll see a checklist on the <strong data-id="element-229" data-mp="2lnjcn7ky7wty">left side</strong> of the screen.
          </>, <>
            Everything under <strong data-id="element-230" data-mp="27nqjz6pv36jc">"Verify your business"</strong> already has a check mark.
            That part is done!
          </>, <>
            Click <strong data-id="element-231" data-mp="2cppm6d9v7xep">"Secure your account"</strong>.
          </>]} data-id="element-228" data-mp="2hnhc51qy99g9" />
    </StepSlide>;
}